import type { HotelsCheckoutTrackingAttributes } from "@b2bportal/core-checkout";

export * from "@b2bportal/core-types/tenant";
export { TenantIconNameEnum } from "./tenantIcons";
export { TenantImageNameEnum } from "./tenantImages";
export { RBC_PACKAGES_QUERY_PARAM } from "./packages";
export type { PackageSearchQueryParams } from "./packages";

export type TenantGlobalTrackingAttributes = HotelsCheckoutTrackingAttributes;

export enum TenantFlightSteps {
  FINTECH_MARKETPLACE = "FINTECH_MARKETPLACE",
  MULTICITY_DEPARTURE0 = "MULTICITY_DEPARTURE0",
  MULTICITY_DEPARTURE1 = "MULTICITY_DEPARTURE1",
  MULTICITY_DEPARTURE2 = "MULTICITY_DEPARTURE2",
  MULTICITY_DEPARTURE3 = "MULTICITY_DEPARTURE3",
  MULTICITY_DEPARTURE4 = "MULTICITY_DEPARTURE4",
}

export enum TenantHotelSteps {
  FINTECH_MARKETPLACE = "FINTECH_MARKETPLACE",
}
